import type { TOC } from '@ember/component/template-only'
import FormEditClassComponent from 'teacher-ui-client/components/form/edit-class'
import type ManageClassesEditClassRoute from 'teacher-ui-client/manage/classes/school-class/route'
import type ManageClassesEditClassController from 'teacher-ui-client/manage/classes/school-class/controller'
import { usesExternalRostering } from 'teacher-ui-client/helpers/uses-external-rostering'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<ManageClassesEditClassRoute>
    controller: ManageClassesEditClassController
  }
}
export const ManageClassesSchoolClassPage: TOC<Signature> = <template>
  {{#if @model}}
    <FormEditClassComponent
      class="m-4"
      @classChangeset={{@model.changeset}}
      @teachers={{@model.teachers}}
      @subscriptionType={{@model.subscriptionType}}
      @onSchoolClassRemovedTeachers={{@controller.onSchoolClassRemovedTeachers}}
      @usesExternalRostering={{(usesExternalRostering)}}
    />
  {{/if}}
</template>

export default RouteTemplate(ManageClassesSchoolClassPage)
